import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { PcLoadingInterceptor } from 'app/shared/services/loading/loading.interceptor';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PcLoadingInterceptor,
      multi: true,
    },
  ],
})
export class PcLoadingModule {}
